import { IconProps } from './IconProps';

export const UpArrowYellow_Trend = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="25"
      height="26"
      viewBox="0 0 25 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.2003 4.08433L21.3217 12.2147C21.7745 12.6679 21.7741 13.4024 21.3209 13.8551C21.1034 14.0724 20.8085 14.1944 20.5011 14.1944L4.25811 14.1944C3.61748 14.1944 3.09814 13.6751 3.09814 13.0344C3.09814 12.727 3.22018 12.4322 3.43744 12.2147L11.5589 4.08433C12.0117 3.63109 12.747 3.63159 13.2003 4.08433C13.2 4.08403 13.2006 4.08463 13.2003 4.08433ZM7.71778 14.1944L17.0414 14.1944L15.3537 20.0737C14.9729 21.4002 13.7596 22.3141 12.3796 22.3141C10.9995 22.3141 9.78632 21.4002 9.40553 20.0737L7.71778 14.1944Z"
        fill="#FFBD3C"
      />
    </svg>
  );
};

